
export default {
  data () {
    return {
      opacity: 0
    };
  },
  mounted () {
    // setRem(document, window);
    this.opacity = 1; // 解决网页加载闪烁问题
    if (process.env.NODE_ENV === "development") {
    } else {
      // window.location.replace("/");
    }
  }
};
